import { Component, OnInit, ViewChild, HostListener, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, style, query, transition, stagger, animate } from '@angular/animations'
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, UntypedFormControl } from '@angular/forms';
import { LanguageService } from 'src/app/services/language/language.service';
import { ThisReceiver } from '@angular/compiler';
import { HttpClient } from '@angular/common/http';
import { MarketSummaryService } from 'src/app/services/data/market-summary.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger("animateMenu", [
      transition(":enter", [
        query("*:not(.status-bar)", [
          style({ opacity: 0, transform: "translateY(-50%)" }),
          stagger(50, [
            animate(
              "250ms cubic-bezier(0.35, 0, 0.25, 1)",
              style({ opacity: 1, transform: "none" }))
          ])
        ])
      ])
    ])
  ]
})



export class HeaderComponent implements OnInit {
  stockNews: any[] = [];
  stockNewsText: string = '';
  searchControl: FormControl = new FormControl();
  stocks: any[] = [];
  filteredStocks: any[] = [];
  responsiveMenuVisible: Boolean = false;
  pageYPosition: number;
  showDropdown = false;
  showSubMenu: boolean = false;
  languageFormControl: UntypedFormControl = new UntypedFormControl();
  cvName: string = "";
  currentDate = new Date();
  formattedDate: string = "";
  purpose: string = "openAccount";
  isMarketOpen = false;
  searchQuery = '';
  openedTab = '';
  isDropdownOpen: boolean = false;
  private closeDropdownTimeout: any;
  constructor(
    private router: Router,
    public analyticsService: AnalyticsService,
    public languageService: LanguageService,
    private http: HttpClient,
    private marketSummaryService: MarketSummaryService
  ) { }

  ngOnInit(): void {

    this.languageFormControl.valueChanges.subscribe(val => this.languageService.changeLanguage(val))

    this.languageFormControl.setValue(localStorage.getItem("language") ?? "en")
    this.fetchStocks();
    this.setupSearch();
    this.updateTime();
    this.checkMarketStatus();
  }

  fetchStocks() {
    this.marketSummaryService.getStocks().subscribe((data: any) => {
      this.stockNews = data;

    });
    this.marketSummaryService.getStocksGridData().subscribe((data: any) => {
      this.stocks = data;
      this.setupSearch();
    });
  }

  changeTab(id: string): void {
    const element = document.getElementById(id);
    const prevElement = document.getElementById(this.openedTab);

    if (id === this.openedTab) {
      element?.classList.remove('d-block');
      this.openedTab = '';
    } else {
      prevElement?.classList.remove('d-block');
      element?.classList.add('d-block');
      this.openedTab = id;
    }

  }
  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  openDropdown() {
    this.showDropdown = true;
  }

  closeDropdown() {
    this.showDropdown = false;
  }

  openMainDropdown() {
    this.isDropdownOpen = true;
    if (this.closeDropdownTimeout) {
      clearTimeout(this.closeDropdownTimeout);
    }
  }

  closeMainDropdown() {
    this.isDropdownOpen = false;
  }

  closeMainDropdownWithDelay() {
    this.closeDropdownTimeout = setTimeout(() => {
      this.closeDropdown();
    }, 3000);
  }

  setupSearch(): void {
    this.searchControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.filteredStocks = this.stocks.filter(stock => stock.englishName.toLowerCase().includes(searchTerm.toLowerCase()));
    });
    console.log(this.filteredStocks);
  }
  onSelectStock(isin: string): void {
    this.filteredStocks = [];
    this.router.navigate(['/stock-details', isin]);
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const searchContainer = document.querySelector('.search-container');
    if (searchContainer && !searchContainer.contains(event.target as Node)) {
      this.filteredStocks = [];
    }
  }

  scroll(el) {
    if (document.getElementById(el)) {
      document.getElementById(el).scrollIntoView({ behavior: 'smooth' });
    } else {
      this.router.navigate(['/home']).then(() => document.getElementById(el).scrollIntoView({ behavior: 'smooth' }));
    }
    this.responsiveMenuVisible = false;
  }
  updateTime() {
    setInterval(() => {
      this.currentDate = new Date();

      if (this.languageFormControl.value === 'ar') {

        this.formattedDate = this.currentDate.toLocaleString('ar-EG-u-nu-latn', {
          // weekday: 'long',
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: true
        });
      } else {

        this.formattedDate = this.currentDate.toLocaleString('en-US', {
          // weekday: 'long',
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: true
        });
      }

    }, 1000);
  }




  navigateToContactUsWithOpenAccount() {
    this.router.navigate(['/contact-us', this.purpose]);
  }


  checkMarketStatus() {
    const now = new Date();
    const day = now.getDay();
    const hour = now.getHours();
    const minutes = now.getMinutes();
    this.isMarketOpen = (day >= 0 && day <= 4) && (hour >= 9 && hour < 14) || (day >= 1 && day <= 5 && hour == 14 && minutes <= 30);
  }

  marketStatus(): string {
    const lang = localStorage.getItem('language') ?? 'en';
    if (lang === 'en') {
      return this.isMarketOpen ? 'Open 🟢' : 'Closed 🔴';
    }
    else {
      return this.isMarketOpen ? 'مفتوح 🟢' : 'مغلق 🔴';
    }
  }

  navigateTo(destination: string): void {
    this.responsiveMenuVisible = false;
    switch (destination) {
      case 'eTrade':
        // window.open('https://trade.aspiresecurities.com/newetrade/login', '_blank');
        window.open('https://trade.aspiresecurities.com/newetrade/login', '_blank');
        break;
      case 'newETrade':
        window.open('https://trade.aspiresecurities.com/newetrade/login', '_blank');
        break;
      case 'ultimateTrade':
        window.open('https://nweb.pioneers-securities.com', '_blank');
        break;
      case 'openAccount':
        window.open('https://nweb.pioneers-securities.com', '_blank');
        break;
      default:
        console.warn('Unknown navigation destination:', destination);
    }
  }

  search() {
    console.log(`Searching for ${this.searchQuery}`);
  }
  closeMenu() {
    this.responsiveMenuVisible = false;
  }

  // downloadCV(){
  //   this.languageService.translateService.get("Header.cvName").subscribe(val => {
  //     this.cvName = val
  //     console.log(val)
  //     // app url
  //     let url = window.location.href;

  //     // Open a new window with the CV
  //     window.open(url + "/../assets/cv/" + this.cvName, "_blank");
  //   })

  // }

  @HostListener('window:scroll', ['getScrollPosition($event)'])
  getScrollPosition(event) {
    this.pageYPosition = window.pageYOffset
  }

  changeLanguage(language: string) {
    this.languageFormControl.setValue(language);
    localStorage.setItem("language", language);
    location.reload();
  }
}
